import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey italic text-sm" }, "Jelaskan alasan mengapa transaksi pengisian BBM ini batal direfund!")
], -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-base required" }, "Alasan", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Simpan")

import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import Button from 'primevue/button'
import { Field, useForm } from 'vee-validate'
import { ref, toRefs, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import * as Yup from 'yup'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinanceCompletedPage',
  props: {
  data: {
    default: null as any
  }
},
  emits: ["hideDialog", "submit"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'submit', data: any): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props

const endpoint = '/transaction/v2/FuelTransactionVouchers'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties




const {
  data
} = toRefs(props)

const initialValues = ref({
  note: ''
})

const schema = Yup.object().shape({
  note: Yup.string()
    .min(3, 'Alasan minimal 3 karakter')
    .max(255, 'Alasan maksimal 255 karakter')
    .matches(rgxExp.notPrefixSpace, 'Alasan tidak boleh hanya menggunakan spasi')
    .required('Alasan harus diisi'),
})

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  initialValues,
  validationSchema: schema
})

const hideDialog = () => {
  emit('hideDialog')
}

const onSubmit = handleSubmit((dataForm: any) => {
  console.log('submit', dataForm)
  emit('submit', dataForm.note)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
        class: "form-container"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(Field), {
            name: "note",
            as: "textarea",
            rows: "5",
            cols: "30",
            maxlength: 255,
            placeholder: "Tulis alasan Anda (Contoh: Nota sudah komplit)",
            class: "",
            id: "note"
          }),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(errors).note), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}
}

})